// src/App.tsx
import { BrowserRouter } from 'react-router-dom';
import { TenantThemeProvider } from '@vanialabs/ui-engine';
import { AppRouter } from './app/router/AppRouter';
import { ThemeProvider } from './theme/ThemeProvider';
import { ErrorBoundary } from './app/components/ErrorBoundary';
import { themeEngine } from './bootstrap/themeEngine.instance';

/**
 * Composition root only. Deliberately kept free of routing/layout/data
 * logic — those live in ./app/router, ./app/layout, and each feature.
 * Add global providers here (theme, query client, etc.) as they appear.
 *
 * Phase 4.7: <TenantThemeProvider> wraps the tree using the existing
 * app-wide `themeEngine` instance from ./bootstrap/themeEngine.instance
 * (the same instance ./theme/ThemeProvider already subscribes to) — no
 * new ThemeEngine is constructed. `binding` stays `null` as a
 * placeholder; no tenant fetching is introduced here.
 */
export function App() {
  return (
    <ThemeProvider>
      <TenantThemeProvider binding={null} themeEngine={themeEngine}>
        <BrowserRouter>
          <ErrorBoundary>
            <AppRouter />
          </ErrorBoundary>
        </BrowserRouter>
      </TenantThemeProvider>
    </ThemeProvider>
  );
}
